import { render, staticRenderFns } from "./RecommendCoupon.vue?vue&type=template&id=37c29b3b&scoped=true&"
import script from "./RecommendCoupon.vue?vue&type=script&lang=js&"
export * from "./RecommendCoupon.vue?vue&type=script&lang=js&"
import style0 from "./RecommendCoupon.vue?vue&type=style&index=0&id=37c29b3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c29b3b",
  null
  
)

export default component.exports